import React from 'react';

const StructuredData = ({ language }) => {
  const businessData = {
    "@context": "https://schema.org",
    "@type": "AutoRepair",
    "name": "Garage Ozcanlar",
    "image": "https://garage-ozcanlar.com/img/logo.png",
    "url": "https://garage-ozcanlar.com",
    "telephone": "+32485935929",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Doornzele Dries 79",
      "addressLocality": "Evergem",
      "postalCode": "9940",
      "addressCountry": "BE"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 51.1167,
      "longitude": 3.7167
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:30"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "09:00",
        "closes": "17:00"
      }
    ],
    "priceRange": "€€",
    "serviceArea": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": 51.1167,
        "longitude": 3.7167
      },
      "geoRadius": "25000"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Services de réparation automobile",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": language === 'fr' ? "Réparation moteur" : language === 'tr' ? "Motor tamiri" : "Motor reparatie"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": language === 'fr' ? "Système de freinage" : language === 'tr' ? "Fren sistemi" : "Remsysteem"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": language === 'fr' ? "Changement de pneus" : language === 'tr' ? "Lastik değişimi" : "Banden wisselen"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": language === 'fr' ? "Entretien général" : language === 'tr' ? "Genel bakım" : "Algemeen onderhoud"
          }
        }
      ]
    }
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(businessData, null, 2) }}
    />
  );
};

export default StructuredData;